export default {"src":"/_next/static/media/vegetables.00adea4f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};